import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Warm the connection to Supabase early so the first RPC pays a shorter
// handshake. Reads the same runtime env supabase.js does (window.__ENV
// injected by entrypoint.sh, with a build-time fallback for local dev).
try {
  const raw =
    (typeof window !== 'undefined' && window.__ENV && window.__ENV.SUPA_URL) ||
    process.env.REACT_APP_SUPA_URL;
  const isPlaceholder = typeof raw === 'string' && raw.startsWith('__RUNTIME_') && raw.endsWith('__');
  const runtimeUrl = isPlaceholder ? process.env.REACT_APP_SUPA_URL : raw;
  if (runtimeUrl) {
    const origin = new URL(runtimeUrl).origin;
    [['preconnect', true], ['dns-prefetch', false]].forEach(([rel, cross]) => {
      const link = document.createElement('link');
      link.rel = rel;
      link.href = origin;
      if (cross) link.crossOrigin = 'anonymous';
      document.head.appendChild(link);
    });
  }
} catch { /* non-fatal — skip preconnect if the URL can't be parsed */ }

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
